<template>
  <v-container>
    <v-btn @click="newSponsor"> New Sponsor </v-btn>
    <v-layout column>
      <v-flex v-for="(sponsor, index) in sponsors" :key="index">
        <v-card>
          <v-layout row align-center>
            <v-flex xs-8 grow>
              <v-card-title>
                {{ sponsor.name }}
              </v-card-title>
            </v-flex>
            <v-flex xs-2 shrink>
              <v-btn @click="() => editSponsor(index)"> Edit </v-btn>
            </v-flex>
            <v-flex xs-2 shrink>
              <v-btn color="warning" @click="() => deleteSponsor(index)">
                Delete
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogOpen" max-width="800px">
      <v-card flat tile height="100%" class="pa-4">
        <v-card-title class="display-1 secondary--text">
          {{ sponsorAlreadyExists ? "Edit Sponsor" : "Add a New Sponsor" }}
        </v-card-title>
        <v-form ref="form" @submit.prevent="submitSponsor">
          <v-text-field
            v-model="sponsorName"
            type="text"
            label="Name"
            :rules="[v => !!v || 'Required']"
          />
          <v-spacer />
          <v-btn type="submit" :disabled="!sponsorName" color="primary">
            Submit
          </v-btn>
          <v-btn @click="dialogOpen = false"> Cancel </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      dialogOpen: false,
      sponsorAlreadyExists: false,
      sponsorName: "",
      currentIndex: -1
    };
  },
  computed: {
    sponsors() {
      return this.$store.state.sponsors;
    }
  },
  mounted() {
    this.$store.dispatch("fetchListings");
    this.$store.dispatch("fetchServices");
  },
  methods: {
    newSponsor() {
      this.sponsorAlreadyExists = false;
      this.sponsorName = "";
      this.currentIndex = -1;
      this.dialogOpen = true;
    },
    editSponsor(index) {
      this.sponsorAlreadyExists = true;
      this.sponsorName = this.sponsors[index].name;
      this.currentIndex = index;
      this.dialogOpen = true;
    },
    deleteSponsor(index) {
      if (confirm("Are you sure you want to delete this sponsor?")) {
        const tempSponsors = _.cloneDeep(this.sponsors);
        tempSponsors.splice(index, 1);
        this.$store.dispatch("updateSponsors", { sponsors: tempSponsors });
      }
    },
    submitSponsor() {
      const tempSponsors = _.cloneDeep(this.sponsors);
      if (this.sponsorAlreadyExists) {
        tempSponsors[this.currentIndex] = { name: this.sponsorName };
      } else {
        tempSponsors.push({ name: this.sponsorName });
      }
      this.$store.dispatch("updateSponsors", { sponsors: tempSponsors });
      this.dialogOpen = false;
    }
  }
};
</script>
